module.exports = __webpack_public_path__ + "static/fonts/rajdhani-semibold-webfont.058bfc5.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/rajdhani-semibold-webfont.woff
// module id = 103
// module chunks = 0